import { useBackendApi } from "./backendApi";
import { ProjectType, TaskType } from './Types';

type Tag = {
  id: string,
  value: string
  isDeprecated: boolean
}

export function useSmartTagsService() {
  const nekstApi = useBackendApi();

  const getSmartTags = async (
    projectType?: ProjectType,
    taskType?: TaskType,
    projectId?: number,
  ) => {
    return await nekstApi.get(`/data/smarttags?taskType=${taskType || ''}&projectType=${projectType || ''}&projectId=${projectId || ''}`) as Tag[];
  };

  return {
    getSmartTags,
  };
}
